/* eslint-disable @next/next/no-img-element */
import { colors } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Slider from "react-slick";

import Container from "~franchise-website/common/Container";

const Maps = ({ themeMode = "light" }) => {
	const theme = useTheme();
	const isXs = useMediaQuery(theme.breakpoints.up("xs"), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up("sm"), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up("md"), {
		defaultMatches: true,
	});
	const isLg = useMediaQuery(theme.breakpoints.up("lg"), {
		defaultMatches: true,
	});

	let slidesToShow = 1;
	if (isXs) {
		slidesToShow = 1;
	}
	if (isSm) {
		slidesToShow = 2;
	}
	if (isMd) {
		slidesToShow = 3;
	}
	if (isLg) {
		slidesToShow = 4;
	}

	const sliderOpts = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow,
		slidesToScroll: 1,
		arrows: false,
	};

	return (
		<Box>
			<Container paddingY="0 !important">
				<Box marginBottom={4}>
					<Typography
						align="center"
						sx={{
							textTransform: "uppercase",
							fontWeight: "medium",
						}}
						gutterBottom
						color="secondary">
						Maps
					</Typography>
					<Box
						component={Typography}
						fontWeight={700}
						variant="h3"
						gutterBottom
						align="center">
						Use cases
					</Box>
					<Typography
						align="center"
						variant="h6"
						component="p"
						color="textSecondary"
					/>
				</Box>
			</Container>
			<Box>
				<Slider {...sliderOpts}>
					{[
						{
							title: "Customer Analysis",
							subtitle:
								"Unveil valuable customer insights and preferences, enabling tailored strategies for enhanced engagement, satisfaction, and business growth.",
							icon: (
								<img
									src="/new-mangomap-assets/images/map_customeranalysis.jpg"
									alt="Customer Analysis img"
								/>
							),
							color: colors.purple,
						},
						{
							title: "Franchise Sales",
							subtitle:
								"Efficiently showcase and sell territories, promoting strategic expansion and sustained growth through data-driven presentations and targeted marketing.",
							icon: (
								<img
									src="/new-mangomap-assets/images/map_franchisesales.jpg"
									alt="Franchise Sales img"
								/>
							),
							color: colors.green,
						},
						{
							title: "Territory Management",
							subtitle:
								"Optimize territory management by allocating resources, maximizing coverage, and streamlining operations for increased productivity and profitability.",
							icon: (
								<img
									src="/new-mangomap-assets/images/franchise-territory-map.png"
									alt="Territory Management img"
								/>
							),
							color: colors.amber,
						},
						{
							title: "Competitor Analysis",
							subtitle:
								"Unlock insights into market trends and opportunities to outpace rivals, paving the way for informed decisions and business success.",
							icon: (
								<img
									src="/new-mangomap-assets/images/map_competitoranalysis.jpg"
									alt="Competitor Analysis img"
								/>
							),
							color: colors.pink,
						},
						{
							title: "Territory Planning",
							subtitle:
								"Enhance territory planning by effectively identifying opportunities, balancing resources, and strategizing for improved market penetration and revenue generation.",
							icon: (
								<img
									src="/new-mangomap-assets/images/franchise-analysis-map.png"
									alt="Territory Planning img"
								/>
							),
							color: colors.blue,
						},
						{
							title: "Site Assessment",
							subtitle:
								"Uncover location suitability, potential risks, and make informed decisions through comprehensive assessment, promoting optimal business outcomes.",
							icon: (
								<img
									src="/new-mangomap-assets/images/franchise-analysis-map.png"
									alt="Site Assessment img"
								/>
							),
							color: colors.teal,
						},
					].map((item, i) => (
						<Box
							padding={{ xs: 1, md: 2, lg: 3 }}
							key={i}>
							<Box
								component={Card}
								boxShadow={{ xs: 1, sm: 3 }}
								borderRadius={5}>
								<Box
									component={CardContent}
									display="flex"
									flexDirection="column"
									alignItems="center"
									padding={{ xs: 2, sm: 4, md: 6 }}
									sx={{
										"&:last-child": {
											paddingBottom: { xs: 2, sm: 4, md: 6 },
										},
									}}>
									<Box
										component={Avatar}
										variant="rounded"
										width={300}
										height={200}
										marginBottom={2}
										bgcolor={
											themeMode === "light" ? item.color[50] : item.color[200]
										}
										borderRadius={5}>
										<Box color={item.color[themeMode === "light" ? 500 : 700]}>
											{item.icon}
										</Box>
									</Box>
									<Box
										component={Typography}
										variant="h6"
										gutterBottom
										fontWeight={500}
										align="center">
										{item.title}
									</Box>
									<Typography
										align="center"
										color="textSecondary">
										{item.subtitle}
									</Typography>
								</Box>
							</Box>
						</Box>
					))}
				</Slider>
			</Box>
		</Box>
	);
};

export default Maps;
